<template>
  <v-app id="reset">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="12" sm="8" md="3">
            <ValidationObserver ref="forms">
              <v-form @submit.prevent="reset">
                <v-card class="elevation-12">
                  <v-card-text class="card-text">
                    <h1 class="text-center mt-6 mb-10 primary--text">
                      Recuperar senha
                    </h1>

                    <v-alert
                      type="info"
                      class="mt-2"
                      v-if="message"
                      text
                      icon="mdi-message-alert-outline"
                    >
                      {{ message.message }}
                    </v-alert>

                    <ValidationProvider
                      name="email"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        label="Email"
                        name="email"
                        prepend-icon="mdi-account"
                        type="email"
                        v-model="email"
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn
                      type="submit"
                      color="primary"
                      :loading="loading"
                      large
                      class="mb-5 px-12 mx-auto"
                    >
                      <v-icon left>mdi-login</v-icon>Recuperar
                    </v-btn>
                  </v-card-actions>

                  <v-row align="center" justify="center">
                    <v-col class="text-center">
                      <router-link to="/login" large>Voltar</router-link>
                    </v-col>
                  </v-row>
                </v-card>
              </v-form>
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-container>

      <v-footer absolute class="text-center">
        <v-card-text class="py-2">
          Powered by
          <strong>Core Coding</strong>
          &copy;{{ new Date().getFullYear() }}
        </v-card-text>
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    email: "",
    password: false,
    message: "",
    loading: false
  }),

  methods: {
    reset() {
      this.$refs.forms.validate().then(r => {
        if (r) {
          this.loading = true;
          this.password = true;
          this.message = "";

          this.$http
            .post("auth/remember_token", { email: this.email })
            .then(res => {
              this.message = res.data;
            })
            .catch(error => console.log(error))
            .then(response => {
              this.loading = false;
              this.email = "";
              this.$refs.forms.reset();
            });
        } else {
          this.message = "";
        }
      });
    }
  }
};
</script>

<style></style>
